"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { Country } from "react-phone-number-input";

const DefaultCountryContext = createContext<Country | undefined>(undefined);

export function DefaultCountryProvider({
  children,
  country,
}: {
  children: ReactNode;
  country: Country | undefined;
}) {
  return (
    <DefaultCountryContext.Provider value={country}>
      {children}
    </DefaultCountryContext.Provider>
  );
}

export function useDefaultCountry(): Country | undefined {
  return useContext(DefaultCountryContext);
}
